import b from 'b_';
import { Chevrone as IconChevrone } from 'education-icons';
import { Text } from 'platform-components';
import React from 'react';
import { connect } from 'react-redux';
import { Action, Dispatch, bindActionCreators } from 'redux';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import * as lessonAssignmentActions from 'common.components/lesson-view.assignment/actions';
import { SIDE_PANEL_MODE } from 'common.components/lesson-view.side-panel/side-panel-mode';
import * as actions from 'common.components/lesson-view.store/actions';

import { actions as sidePanelActions } from '../actions';
import * as selectors from '../selectors';
import { LessonViewSidePanelStore } from '../typings';

import './side-panel__assign-header.scss';
import './side-panel__assign-header_mobile.scss';

interface StoreProps {
    mode: SIDE_PANEL_MODE;
    isExpanded: boolean;
}

interface DispatchProps {
    setShouldShowAssignmentSettings: typeof actions.setShouldShowAssignmentSettings;
    setAssignmentToDefault: typeof lessonAssignmentActions.setToDefault;
    setExpanded: typeof sidePanelActions.setExpanded;
}

export interface Props extends StoreProps, DispatchProps {}

export const SidePanelAssignHeaderMobile = (props: Props) => {
    const { mode, setShouldShowAssignmentSettings, setAssignmentToDefault, setExpanded, isExpanded } = props;

    const onAssignHeaderBackClick = () => {
        setShouldShowAssignmentSettings(false);
        setAssignmentToDefault();
    };

    const onHeaderClick = () => {
        setExpanded(!isExpanded);
    };

    return (
        <>
            {mode === SIDE_PANEL_MODE.REASSIGNMENT && (
                <div className="side-panel__assign-header-back" {...accessibleClick(onAssignHeaderBackClick)}>
                    <Text id="lessonView.sidePanel.reassignment.back" />
                </div>
            )}
            <div
                className={b('side-panel', 'assignment-header-title', { expanded: isExpanded })}
                {...accessibleClick(onHeaderClick)}
            >
                <IconChevrone className={b('side-panel', 'mobile-expand', { expanded: isExpanded })} />
                <Text
                    id={
                        mode === SIDE_PANEL_MODE.ASSIGNMENT
                            ? 'assignLessonModal.title'
                            : 'lessonView.sidePanel.reassignment.title'
                    }
                    size={Text.SIZE.XL}
                    weight={Text.WEIGHT.M}
                />
            </div>
        </>
    );
};

const mapStateToProps = <T extends { lessonViewSidePanel: LessonViewSidePanelStore }>(storeState: T): StoreProps => {
    return {
        mode: selectors.getSidePanelMode(storeState),
        isExpanded: selectors.getIsExpanded(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            setShouldShowAssignmentSettings: actions.setShouldShowAssignmentSettings,
            setAssignmentToDefault: lessonAssignmentActions.setToDefault,
            setExpanded: sidePanelActions.setExpanded,
        },
        dispatch
    );
};

const connected = connect(mapStateToProps, mapDispatchToProps)(SidePanelAssignHeaderMobile);
connected.displayName = 'AssignHeaderMobile';

export default connected;
